// shuttle list and items constants
var itemAnimationDuration = 300;
var listAnimationDuration = 300;
var xPosMovement = 500; // breadcrumb constants

var breadcrumbDuration = 200;
var xBreadcrumbPos = 300;
var animationConfig = {
  slideRight: {
    from: {
      transform: 'translate3d(0,0,0)'
    },
    to: {
      transform: "translate3d(".concat(xPosMovement, "px,0,0)")
    }
  },
  slideLeft: {
    from: {
      transform: 'translate3d(0,0,0)'
    },
    to: {
      transform: "translate3d(".concat(-xPosMovement, "px,0,0)")
    }
  },
  moveItem: function moveItem(isMovingLeft) {
    return {
      config: {
        duration: itemAnimationDuration
      },
      enter: {
        opacity: 1,
        transform: "translate3d(".concat(0, "px,0,0)")
      },
      from: {
        opacity: 1,
        transform: "translate3d(".concat(isMovingLeft ? -xPosMovement : xPosMovement, "px,0,0)")
      },
      leave: {
        transform: "translate3d(".concat(isMovingLeft ? -xPosMovement : xPosMovement, "px,0,0)")
      }
    };
  },
  moveList: function moveList(isDrillingDown) {
    return {
      config: {
        duration: listAnimationDuration
      },
      enter: {
        opacity: 1,
        transform: 'translate3d(0,0,0)'
      },
      from: {
        opacity: 0,
        transform: "translate3d(0px,".concat(isDrillingDown ? xPosMovement : -xPosMovement, "px,0)")
      },
      leave: {
        opacity: 0,
        transform: "translate3d(0,".concat(isDrillingDown ? -xPosMovement : xPosMovement, "px,0)")
      }
    };
  },
  breadcrumb: function breadcrumb() {
    return {
      config: {
        duration: breadcrumbDuration
      },
      enter: {
        opacity: 1,
        transform: "translate3d(".concat(0, "px,0,0)")
      },
      from: {
        opacity: 0,
        transform: "translate3d(".concat(xBreadcrumbPos, "px,0px,0)")
      },
      leave: {
        opacity: 0,
        transform: "translate3d(".concat(xBreadcrumbPos, "px,0,0)")
      }
    };
  }
};

export { animationConfig };
//# sourceMappingURL=animationConfig.js.map
